var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loading"},[_vm._t("default",[_c('i',{staticClass:"loading-1"}),_c('i',{staticClass:"loading-2"}),_c('i',{staticClass:"loading-3"})])],2)}
var staticRenderFns = []

export { render, staticRenderFns }